(function () {
  function initUseCases(root) {
    var sections = root.querySelectorAll('[data-speakon-use-cases]');

    sections.forEach(function (section) {
      if (section.dataset.useCasesInitialized === 'true') return;

      var track = section.querySelector('[data-use-cases-track]');
      var viewport = section.querySelector('.speakon-use-cases__viewport');
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-use-cases-card]'));
      var prev = section.querySelector('[data-use-cases-prev]');
      var next = section.querySelector('[data-use-cases-next]');

      if (!track || !viewport || !cards.length || !prev || !next) return;

      section.dataset.useCasesInitialized = 'true';

      var offset = 0;
      var renderFrame = null;
      var mediaQuery = window.matchMedia('(max-width: 767.98px)');
      var isStylesVariant = section.dataset.useCasesVariant === 'styles';

      function getGap() {
        var styles = window.getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap || 0) || 0;
      }

      function rectanglesOverlapVertically(first, second) {
        return first.bottom > second.top && first.top < second.bottom;
      }

      function getObstructionShift() {
        if (mediaQuery.matches || isStylesVariant) return 0;

        var viewportRect = viewport.getBoundingClientRect();
        var popups = Array.prototype.slice.call(document.querySelectorAll('.as-subscribe-popup'));
        var safetyGap = 24;
        var largestShift = 0;

        popups.forEach(function (popup) {
          var styles = window.getComputedStyle(popup);
          var rect = popup.getBoundingClientRect();
          var isHidden =
            styles.display === 'none' ||
            styles.visibility === 'hidden' ||
            parseFloat(styles.opacity || 1) < 0.1 ||
            rect.width === 0 ||
            rect.height === 0;

          if (isHidden || !rectanglesOverlapVertically(viewportRect, rect)) return;

          var intrusion = viewportRect.right - (rect.left - safetyGap);
          if (intrusion > 0) largestShift = Math.max(largestShift, intrusion);
        });

        if (!largestShift) return 0;

        var cardWidth = cards[0].getBoundingClientRect().width;
        return Math.min(largestShift, cardWidth + getGap());
      }

      function getStep() {
        return cards[0].getBoundingClientRect().width + getGap();
      }

      function getMaxOffset() {
        var naturalOverflow = Math.max(0, track.scrollWidth - viewport.clientWidth);
        return naturalOverflow + getObstructionShift();
      }

      function render() {
        var maxOffset = getMaxOffset();
        var epsilon = 1;

        offset = Math.max(0, Math.min(offset, maxOffset));

        track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
        prev.disabled = offset <= epsilon;
        next.disabled = offset >= maxOffset - epsilon;
      }

      function scheduleRender() {
        if (renderFrame !== null) return;

        renderFrame = window.requestAnimationFrame(function () {
          renderFrame = null;
          render();
        });
      }

      prev.addEventListener('click', function () {
        offset = Math.max(0, offset - getStep());
        render();
      });

      next.addEventListener('click', function () {
        offset = Math.min(getMaxOffset(), offset + getStep());
        render();
      });

      var popupObserver = new MutationObserver(scheduleRender);

      function observePopups() {
        document.querySelectorAll('.as-subscribe-popup').forEach(function (popup) {
          popupObserver.observe(popup, {
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden'],
          });
        });
      }

      var popupDiscoveryObserver = new MutationObserver(function () {
        observePopups();
        scheduleRender();
      });

      popupDiscoveryObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });

      observePopups();

      window.addEventListener('resize', scheduleRender);
      window.addEventListener('scroll', scheduleRender, { passive: true });
      render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initUseCases(document);
    });
  } else {
    initUseCases(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initUseCases(event.target);
  });
})();
